"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PagingInfo = PagingInfo;
exports.createPaging = exports.comparePaging = void 0;
exports.default = Paging;
var React = _interopRequireWildcard(require("react"));
var _utils = require("./utils");
var _Icon = _interopRequireDefault(require("./Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var createPaging = function createPaging(page) {
  return {
    page: page || 1,
    pageCount: page || 1,
    row: 0,
    rowCount: 0,
    rowPerPage: 0
  };
};
exports.createPaging = createPaging;
var comparePaging = function comparePaging(p1, p2) {
  return JSON.stringify(p1) !== JSON.stringify(p2);
};
exports.comparePaging = comparePaging;
function Paging(props) {
  if (!props.paging) return null;
  var margin = props.gap || 1;
  var marginDot = margin + 1;
  var page = props.paging.page;
  var pageCount = props.paging.pageCount || 1;
  var items = [];
  var lastDot = false;
  var onChange = function onChange(index) {
    return props.onChange && props.onChange(_objectSpread(_objectSpread({}, props.paging), {}, {
      page: index
    }), index);
  };
  var _loop = function _loop(x) {
    if (x <= marginDot || x > pageCount - marginDot || x >= page - margin && x <= page + margin) {
      items.push( /*#__PURE__*/React.createElement("div", {
        key: 'paging_' + x,
        className: (0, _utils.clsNames)('_btn', page === x && '-active'),
        onClick: function onClick() {
          return onChange(x);
        }
      }, x));
      lastDot = false;
      return "continue";
    }
    if (!lastDot) {
      items.push( /*#__PURE__*/React.createElement(_Icon.default, {
        key: x,
        name: 'ellipsis-h',
        className: "_divider"
      }));
      lastDot = true;
    }
  };
  for (var x = 1; x <= pageCount; x++) {
    var _ret = _loop(x);
    if (_ret === "continue") continue;
  }
  if (!!props.prepend || !!props.append) return /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-paging-container', props.className)
  }, !!props.prepend && /*#__PURE__*/React.createElement("div", {
    className: "un-paging-pend"
  }, props.prepend), /*#__PURE__*/React.createElement("div", {
    className: "un-paging"
  }, items), !!props.append && /*#__PURE__*/React.createElement("div", {
    className: "un-paging-pend"
  }, props.append), !!props.showInfo && /*#__PURE__*/React.createElement("div", {
    className: "un-paging-pend"
  }, /*#__PURE__*/React.createElement(PagingInfo, {
    paging: props.paging
  })));
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-paging', props.className)
  }, items);
}
function PagingInfo(props) {
  var paging = props.paging;
  if (!paging) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "un-paging-info"
  }, /*#__PURE__*/React.createElement("span", {
    className: "_label"
  }, "\u0E2B\u0E19\u0E49\u0E32"), /*#__PURE__*/React.createElement("span", {
    className: "_value"
  }, paging.page), /*#__PURE__*/React.createElement("span", {
    className: "_label"
  }, "/ ", paging.pageCount), /*#__PURE__*/React.createElement("span", {
    className: "_label ml-2"
  }, "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48"), /*#__PURE__*/React.createElement("span", {
    className: "_value"
  }, (paging.page - 1) * paging.rowPerPage + 1, " - ", paging.page * paging.rowPerPage > paging.rowCount ? paging.rowCount : paging.page * paging.rowPerPage), /*#__PURE__*/React.createElement("span", {
    className: "_label"
  }, "\u0E08\u0E32\u0E01"), /*#__PURE__*/React.createElement("span", {
    className: "_value"
  }, paging.rowCount), /*#__PURE__*/React.createElement("span", {
    className: "_label"
  }, "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23"));
}